import { useCurrentEnterpriseId } from '@mews-commander/core';
import { useRepositoryMutation } from '@mews-commander/data-access';
import { WithProductId } from '@mews-commander/types';
import { useDeleteConfirmationDialog } from '@mews-commander/ui';
import { lt, showSuccessAlert } from '@mews/framework';

interface Params extends WithProductId {
    onSuccess?: () => void;
}
export const useDeleteProductDialog = ({ productId, onSuccess }: Params) => {
    const currentEnterpriseId = useCurrentEnterpriseId();
    const { mutateAsync } = useRepositoryMutation('products', 'delete', {
        invalidateQueries: { products: ['getOverviewEntries', 'getAll'] },
        onSuccess: () => {
            showSuccessAlert({
                title: lt('DeleteProductSuccessMessage'),
            });
            onSuccess?.();
        },
    });

    return useDeleteConfirmationDialog({
        deleteAction: async () => mutateAsync({ productIds: [productId], enterpriseIds: [currentEnterpriseId] }),
        renderContent: () => lt('DeleteProductDialogDescription'),
        title: lt('DeleteProductDialogTitle'),
    });
};
